module.exports = __webpack_public_path__ + "static/media/ruangguru-logo-white.7a5a925c.png";